import React from "react";
import { styled } from "@mui/system";
import { connect } from "react-redux";
import MessengerContent from "./MessengerContent"
import HomeView from "./HomeView";
const MainContainer = styled("div")({
  flexGrow: 1,
  backgroundColor: "#1f2024",
  marginTop: "48px",
  display: "flex",
});

const Messenger = ({chosenChatDetails, selectedServer}) => {
  return <MainContainer>

    {
      !chosenChatDetails && !selectedServer ? (<HomeView />) : (
        chosenChatDetails ? <MessengerContent chosenChatDetails={chosenChatDetails}/> : null
      )
    }
  </MainContainer>;
};
const mapStoreStateToProps=({chat, room})=>{
  return {
    ...chat,
    selectedServer: room.selectedServer,
  }
}

export default connect(mapStoreStateToProps)(Messenger);
